<button kendoButton kendoTooltip type="{{type}}" [title]="title" [look]="'flat'" [style.width]="width + 'px'" (click)="handleClick($event)" [icon]="icon" [class]="buttonClass + additionalClass" [disabled]="disabled">
  <span *ngIf="text" class="text">{{text}}</span>
</button>
